import { takeLatest } from 'redux-saga/effects';
import {
	getPendingApprovalSuccess, getPendingApprovalFail,
	getUpcomingBirthdaySuccess, getUpcomingBirthdayFail,
	getLeaveApprovedListSuccess, getLeaveApprovedListFail,
	getDailyAttendanceSummarySuccess, getDailyAttendanceSummaryFail,
	getHolidayListSuccess, getHolidayListFail,
	getTeamOverviewStatSuccess, getTeamOverviewStatFail,
	getTeamEnrollmentStatSuccess, getTeamEnrollmentStatFail,
	getWeeklyAttendanceSuccess, getWeeklyAttendanceFail,
	getTeamCourseStatSuccess, getTeamCourseStatFail,
	getTeamModuleStatSuccess, getTeamModuleStatFail,
	getEmployeeCountSuccess, getEmployeeCountFail,
	getMonthlyAttendanceSummarySuccess, getMonthlyAttendanceSummaryFail,
	getTicketDepartmentMatrixSuccess, getTicketDepartmentMatrixFail,
	getRecognitionStatsSuccess, getRecognitionStatsFail,
	getLeaveBalanceSuccess, getLeaveBalanceFail
} from './overviewState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, LOADING_MSG,
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/overview');

function* getPendingApproval(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('pending-approval-list', data.payload), 
		getPendingApprovalSuccess, 
		getPendingApprovalFail, null, null, LOADING_MSG);
}

function* getUpcomingBirthday(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('upcoming-birthday-list', data.payload), 
		getUpcomingBirthdaySuccess, 
		getUpcomingBirthdayFail, null, null, LOADING_MSG);
}

function* getLeaveApprovedList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('approved-leaves-list', data.payload), 
		getLeaveApprovedListSuccess, 
		getLeaveApprovedListFail, null, null, LOADING_MSG);
}

function* getDailyAttendanceSummary(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('employee-attendance', data.payload), 
		getDailyAttendanceSummarySuccess, 
		getDailyAttendanceSummaryFail, null, null, LOADING_MSG);
}
function* getWeeklyAttendance(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('employee-attendance-weekly', data.payload), 
		getWeeklyAttendanceSuccess, 
		getWeeklyAttendanceFail, null, null, LOADING_MSG);
}
function* getHolidayList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('holiday-list', data.payload), 
		getHolidayListSuccess, 
		getHolidayListFail, null, null, LOADING_MSG);
}

function* getTeamOverviewStat(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/overview-stats', data.payload), 
		getTeamOverviewStatSuccess, 
		getTeamOverviewStatFail, null, null, LOADING_MSG);
}

function* getTeamEnrollmentStat(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/enrollment-stats', data.payload), 
		getTeamEnrollmentStatSuccess, 
		getTeamEnrollmentStatFail, null, null, LOADING_MSG);
}

function* getTeamCourseStat(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/course-stats', data.payload), 
		getTeamCourseStatSuccess, 
		getTeamCourseStatFail, null, null, LOADING_MSG);
}

function* getTeamModuleStat(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/module-stats', data.payload), 
		getTeamModuleStatSuccess, 
		getTeamModuleStatFail, null, null, LOADING_MSG);
}

function* getEmployeeCount(data) {
    yield doCrudCall(
        () => crudService.doGetRequest('statistics/total-employees', data.payload),
        getEmployeeCountSuccess,
        getEmployeeCountFail,
        null,
        null,
        LOADING_MSG
    );
}

function* getMonthlyAttendanceSummary(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('employee-attendance-monthly', data.payload),
		getMonthlyAttendanceSummarySuccess,
		getMonthlyAttendanceSummaryFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getTicketDepartmentMatrix(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/support-ticket-stats', data.payload),
		getTicketDepartmentMatrixSuccess,
		getTicketDepartmentMatrixFail,
	);
}

function* getRecognitionStats(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('recognition-stats', data.payload),
		getRecognitionStatsSuccess,
		getRecognitionStatsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getLeaveBalance(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('leave-balance', data.payload),
		getLeaveBalanceSuccess,
		getLeaveBalanceFail,
		null,
		null,
		LOADING_MSG
	);
}

function* overviewSaga() {
	yield takeLatest('overview/getPendingApproval', getPendingApproval); 
	yield takeLatest('overview/getUpcomingBirthday', getUpcomingBirthday);
	yield takeLatest('overview/getLeaveApprovedList', getLeaveApprovedList);
	yield takeLatest('overview/getDailyAttendanceSummary', getDailyAttendanceSummary);
	yield takeLatest('overview/getWeeklyAttendance', getWeeklyAttendance);
	yield takeLatest('overview/getHolidayList', getHolidayList);
	yield takeLatest('overview/getTeamOverviewStat', getTeamOverviewStat);
	yield takeLatest('overview/getTeamEnrollmentStat', getTeamEnrollmentStat);
	yield takeLatest('overview/getTeamCourseStat', getTeamCourseStat);
	yield takeLatest('overview/getTeamModuleStat', getTeamModuleStat);
	yield takeLatest('overview/getEmployeeCount', getEmployeeCount);
	yield takeLatest('overview/getMonthlyAttendanceSummary', getMonthlyAttendanceSummary);
	yield takeLatest('overview/getTicketDepartmentMatrix', getTicketDepartmentMatrix);
	yield takeLatest('overview/getRecognitionStats', getRecognitionStats);
	yield takeLatest('overview/getLeaveBalance', getLeaveBalance);
}

export default overviewSaga;
